import { ColDef } from '@ag-grid-community/core';
import { isNil } from '@benzinga/utils';

const capitalizeFirstLetter = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

const formatHeaderClass = (str: string) =>
  capitalizeFirstLetter(str)
    .replace(/\s/g, '_')
    .trim()
    .replace(/[^\w\s]/g, '');

const getArrayToAppend = (headerClass: ColDef['headerClass']) =>
  Array.isArray(headerClass) ? headerClass : typeof headerClass === 'string' ? [headerClass] : [];

const wrapFunction = (fn: (params: any) => string | string[] | undefined) => {
  return (appendString: string) => {
    return (params: any) => {
      const fnValue = fn(params);
      const fnValueArray = Array.isArray(fnValue) ? fnValue : [fnValue];
      return [...fnValueArray, appendString];
    };
  };
};

export const addTutorialClasses = <T extends ColDef>(columnDefs: T[], gridName: string): T[] =>
  columnDefs.map(columnDef => {
    const headerNameOrField = columnDef.headerName || columnDef.field;
    const headerClass = columnDef.headerClass;

    if (isNil(headerNameOrField)) {
      return columnDef;
    }

    const formattedHeaderNameOrField = formatHeaderClass(headerNameOrField);
    const gridNameCapitalized = capitalizeFirstLetter(gridName);
    const appendString = `TUTORIAL_ag_header_${gridNameCapitalized}_${formattedHeaderNameOrField}`;

    return isNil(headerClass)
      ? { ...columnDef, headerClass: appendString }
      : typeof headerClass === 'function'
        ? { ...columnDef, headerClass: wrapFunction(headerClass)(appendString) }
        : { ...columnDef, headerClass: [...appendString, getArrayToAppend(headerClass)] };
  });
